import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MedicalRecord } from '../../core/models/patient-medical-record';

@Component({
  selector: 'app-patient-health-history',
  imports: [DatePipe],
  templateUrl: './patient-health-history.html',
  styleUrl: './patient-health-history.scss',
})
export class PatientHealthHistory {
  @Input() healthHistory: MedicalRecord[] = [];
}
